import React from "react";

function Header() {
  return (
    <header>
      <img
        src="https://cdn.vectorstock.com/i/1000x1000/18/96/hotel-icon-vector-46581896.webp"
        alt="Hotel Booking Logo"
      />
      <h1>Hotel Booking</h1>
    </header>
  );
}

export default Header;
